import { buildTranslate } from 'locales'
import { MultiUseRewardsSettings } from '../../FormModel'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.multi_use_rewards_card'
)

export type PresetKey = 'daily' | 'weekly' | 'monthly' | 'yearly' | 'custom'

export type PresetConfig = {
  limitType: 'set_number' | 'unlimited'
  maxIssuancesPerWindow?: number
  windowDuration?: number
  maxIssuances?: number | null
  activeWindowDuration: number
}

export type Preset = {
  key: PresetKey
  title: string
  description: string
  config?: PresetConfig
}

export const PRESETS: Preset[] = [
  {
    key: 'daily',
    title: t('preset_daily_title'),
    description: t('preset_daily_description'),
    config: {
      limitType: 'set_number',
      maxIssuancesPerWindow: 1,
      windowDuration: 1,
      maxIssuances: null,
      activeWindowDuration: 30,
    },
  },
  {
    key: 'weekly',
    title: t('preset_weekly_title'),
    description: t('preset_weekly_description'),
    config: {
      limitType: 'set_number',
      maxIssuancesPerWindow: 1,
      windowDuration: 7,
      maxIssuances: null,
      activeWindowDuration: 30,
    },
  },
  {
    key: 'monthly',
    title: t('preset_monthly_title'),
    description: t('preset_monthly_description'),
    config: {
      limitType: 'set_number',
      maxIssuancesPerWindow: 1,
      windowDuration: 30,
      maxIssuances: null,
      activeWindowDuration: 365,
    },
  },
  {
    key: 'yearly',
    title: t('preset_yearly_title'),
    description: t('preset_yearly_description'),
    config: {
      limitType: 'set_number',
      maxIssuancesPerWindow: 1,
      windowDuration: 7,
      maxIssuances: null,
      activeWindowDuration: 365,
    },
  },
  {
    key: 'custom',
    title: t('preset_custom_title'),
    description: t('preset_custom_description'),
  },
]

export function detectPreset(
  settings: MultiUseRewardsSettings
): PresetKey | null {
  if (settings.usageType !== 'multiple_times') return null

  for (const preset of PRESETS) {
    const config = preset.config
    if (!config) continue
    if (
      settings.limitType === config.limitType &&
      settings.maxIssuancesPerWindow === config.maxIssuancesPerWindow &&
      settings.windowDuration === config.windowDuration
    ) {
      const maxIssuancesMatch =
        config.maxIssuances == null
          ? settings.maxIssuances == null
          : settings.maxIssuances === config.maxIssuances
      const activeWindowMatch =
        !config.activeWindowDuration ||
        settings.activeWindowDuration === config.activeWindowDuration
      if (maxIssuancesMatch && activeWindowMatch) return preset.key
    }
  }

  const hasConfig =
    settings.limitType === 'unlimited' ||
    settings.maxIssuancesPerWindow ||
    settings.windowDuration ||
    settings.activeWindowDuration ||
    settings.maxIssuances
  if (hasConfig) return 'custom'

  return null
}
